import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FileuploadComponent } from './fileupload.component';
import { FileuploadRoutingModule } from './fileupload-routing.module';

import { CatalogueModule } from './../../component/catalogue/catalogue.module';
import { DemoModule } from './../../component/demo/demo.module';
import { CodeModule } from './../../component/code/code.module';

import {FileUploadModule} from "../../component/ing/fileupload/fileupload";
import {TableModule} from "../../component/ing/table/table";
import {GrowlModule} from "../../component/ing/growl/growl";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    FileuploadRoutingModule,
    CatalogueModule,
    DemoModule,
    CodeModule,
    FileUploadModule,
    TableModule,
    GrowlModule
  ],
  declarations: [FileuploadComponent]
})
export class FileuploadDemoModule { }



// WEBPACK FOOTER //
// ./src/app/view/fileupload/fileuploadDemo.module.ts